import { Row, Col, Form, Input, Button, DatePicker } from 'antd';
import { Link } from 'react-router-dom';
import 'moment/locale/es';
import locale from 'antd/es/date-picker/locale/es_ES';
import { useTranslation } from 'react-i18next';
import History from '../../components/History';

const PatientSearch = ({
  reloadSearch,
  countryCode,
  historyParams
}) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const removeFilters = () => {
    form.resetFields();
  };

  return (
    <Col lg={24} xs={24}>
      <Row justify="center" className="patient-search">
        <Col lg={24} xs={24} className="patient-page-wrapper__header pt-20">
          <Row justify="center">
            <Col lg={22} xs={22}>
              <Row justify="space-between" align="middle">
                <Col className="back-button-wrapper">
                  <Link to="/reservas/fecha">
                    <i className="icon-system-chevron-left" />
                    Volver
                  </Link>
                </Col>
                <Col>
                  <History params={historyParams} />
                </Col>
                <Col lg={24} xs={24}>
                  <h1 className="text-center mb-10">Ingresos</h1>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col lg={24} xs={24} className="mt-lg-30 mt-md-40 mt-sm-40 mt-xs-40">
          <Row justify="center">
            <Col lg={22} xs={22}>
                <Form
                  form={form}
                  onFinish={reloadSearch}
                  size="large"
                >
                  <Row gutter={15} className="form-wrapper">
                    <Col lg={5} xs={24}>
                      <Form.Item name="reservation_number">
                        <Input
                          className="cmt-input"
                          placeholder={t('admissionPatientPage.patientSearch.searchPlaceholder')}
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={6} xs={24}>
                      <Form.Item name="patient_rut">
                        <Input
                          className="cmt-input"
                          placeholder={t('admissionPatientPage.patientSearch.documentNumberPlaceholder')}
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={6} xs={24}>
                      <Form.Item name="company_rut">
                        <Input
                          className="cmt-input"
                          placeholder={t('admissionPatientPage.patientSearch.companyPlaceholder')}
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={3} xs={24}>
                      <Form.Item name="admission_date">
                        <DatePicker
                          className="date-picker"
                          locale={locale}
                          inputReadOnly={true}
                          placeholder="Fecha"
                          dropdownClassName="custom-dropdown"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col className="button-wrapper mr-lg-0 mr-md-15 mr-sm-15 mr-xs-15">
                      <Button className="cmt-button primary" type="primary" htmlType="submit">
                        Buscar
                      </Button>
                    </Col>
                    <Col>
                      <Button className="cmt-button primary outline borderless" onClick={removeFilters}>
                        Borrar filtros
                      </Button>
                    </Col>
                  </Row>
                </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

export default PatientSearch;